<template>
    <div v-bind:class="className" v-if="filterCabang.length > 1">
        <b-form-group class="cabang-custom-select mb-0">
            <multiselect
                class="ml-0"
                    name="filterCabang"
                    v-model="input.filterCabang" 
                    :options="filterCabang" 
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="name"
                />
        </b-form-group>
    </div>
    <span class="header-user-cabang" v-else>{{ cabang }}</span>
</template>

<script>
export default {
    name: 'CabangOption',
    data() {
        return {
			input:{
				filterCabang: null,
			},
            filterCabang:[],
            cabang: localStorage.getItem("activeCabang")
        }
    }, 
    props: {
        className: { type: String, required: false}
    },
    watch: {
        'input.filterCabang': function(newVal) {
			console.log(newVal)
            localStorage.setItem("activeCabangId", newVal.id)
		}
    },
    methods: {
		init(){
			let getCabang = localStorage.getItem("cabang")
            this.filterCabang = JSON.parse(getCabang)
            let idActiveCabang = this.$helper.getCabangId()
            let idx = this.filterCabang.findIndex(item => item.id == idActiveCabang);
            this.input.filterCabang = this.filterCabang[idx]
        },
        handleResize() {
            let idActiveCabang = this.$helper.getCabangId()
            let idx = this.filterCabang.findIndex(item => item.id == idActiveCabang);
            this.input.filterCabang = this.filterCabang[idx]
        },
    },
    created() {
        this.init()
        window.addEventListener("resize", this.handleResize);
    }
}
</script>